"use strict";
$(function ($) {
  /* ドロワーメニュー */
   /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click')
  });
});



/* ----- メガメニュー ----- */
// メガメニューのホバー表示制御
document.addEventListener('DOMContentLoaded', function() {
  const megaMenuBtns = document.querySelectorAll('.megaMenu__btn');

  megaMenuBtns.forEach(btn => {
    const container = btn.querySelector('.megaMenu__container');

    if (container) {
      btn.addEventListener('mouseenter', function() {
        container.classList.add('is-visible');
      });

      btn.addEventListener('mouseleave', function() {
        container.classList.remove('is-visible');
      });
    }
  });
});


/* ----- FVスライダー ----- */
document.addEventListener('DOMContentLoaded', function() {
  const fvSlider = document.querySelector('.fv__slider');

  if (fvSlider) {
    new Swiper('.fv__slider', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.fv__pagination',
        clickable: true,
      },
    });
  }
});


$(function () {
    // フェードイン判定の共通関数
    function checkFadeElements() {
        let windowHeight = $(window).height(),
            scroll = $(window).scrollTop();

        $(".fade").each(function () {
            var targetPosition = $(this).offset().top;
            if (scroll > targetPosition - windowHeight + 100) {
                $(this).addClass("is-active");
            }
        });
    }

    // アンカーリンク付きの場合のみ初期チェック
    if (window.location.hash) {
        checkFadeElements();
    }

    // スクロール時のチェック
    $(window).scroll(function () {
        checkFadeElements();
    });
});



// /* ----- qaアコーディオン ----- */
// $(".qa__question").on("click", function() {
//   $(this).next().slideToggle();
//   $(this).toggleClass("is-active");
// });

/* ----- menuアコーディオン ----- */
$(".menu__btn").on("click", function() {
  // 768px未満の場合のみ動作
  if (window.innerWidth < 768) {
    $(this).next().slideToggle();
    $(this).toggleClass("is-active");
  }
});

// リサイズ時に状態をリセット
$(window).on("resize", function() {
  if (window.innerWidth >= 768) {
    $(".menu__btn").next().removeAttr("style");
    $(".menu__btn").removeClass("is-active");
  }
});

/* ----- サイドバーアコーディオン ----- */
$(".sidebar__article").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});


/* ----- スムースクロール ----- */
document.addEventListener('DOMContentLoaded', function() {
  // 固定ヘッダー（固定しない場合は = 0）
  const headerElement = document.querySelector('header');
  const headerHeight = headerElement ? headerElement.offsetHeight : 0; // ヘッダーが存在しない場合は0に設定

  // スマホサイズの時の追加オフセット（必要に応じて調整）
  const mobileOffset = -10; // 10px 追加オフセット
  // PCサイズの時の追加オフセット（必要に応じて調整）
  const pcOffset = 0; // 5px 上に調整

  // ページ内のスムーススクロール
  const anchorLinks = document.querySelectorAll('a[href*="#"]');

  if (anchorLinks && anchorLinks.length > 0) {
    anchorLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        const hash = e.currentTarget.hash;

        // ページトップへ("#"と"#top"）
        if (!hash || hash === '#top') {
          e.preventDefault();
          window.scrollTo({
            top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
            behavior: 'smooth',
          });
        }
        // アンカーへ
        else if (hash.slice(1)) {
          const target = document.getElementById(hash.slice(1));
          if (target) {
            e.preventDefault();
            let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

            // スマホサイズの場合の追加オフセット
            if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
              position += mobileOffset;
            } else {
              // PCサイズの場合の追加オフセット
              position += pcOffset;
            }

            window.scrollTo({
              top: position,
              behavior: "smooth",
            });

            // URLにハッシュを含める
            history.pushState(null, '', hash);
          }
        }
      });
    });
  }
});


/* ----- 在庫車フィルタリング（最終修正版） ----- */
jQuery(document).ready(function($) {
    // 在庫車フィルターが存在する場合のみ実行
    if ($('#car_jp_filter').length === 0) return;

    let currentFilters = {
        car_jp: '',
        car_world: '',
        paged: 1
    };

    // フィルターが適用されているかどうかの判定
    function hasActiveFilters() {
        return currentFilters.car_jp !== '' ||
                currentFilters.car_world !== '';
    }

    // フィルター変更時の処理
    function handleFilterChange() {
        currentFilters.car_jp = $('#car_jp_filter').val();
        currentFilters.car_world = $('#car_world_filter').val();
        currentFilters.paged = 1; // ページをリセット

        filterStockCars();
    }

    // Ajaxでフィルタリング実行
    function filterStockCars() {
        $('#stock-items').addClass('loading');

        // Ajax URLの設定
        const ajaxUrl = typeof ajax_object !== 'undefined' ? ajax_object.ajax_url : '/wp-admin/admin-ajax.php';

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'filter_stock_cars',
                car_jp: currentFilters.car_jp,
                car_world: currentFilters.car_world,
                paged: currentFilters.paged
            },
            success: function(response) {
                if (response.success) {
                    // コンテンツの更新
                    $('#stock-items').html(response.content);

                    // ページネーションの更新
                    $('#pagination-container .nav-links').html(response.pagination || '');

                    // 件数表示の更新
                    $('#results-count').text('全 ' + response.total + ' 件');

                    // フェードインを再適用
                    setTimeout(function() {
                        document.dispatchEvent(new CustomEvent('stockFiltered'));
                    }, 100);

                    // コンソールに総数を表示
                    console.log('=== 在庫車フィルター結果 ===');
                    console.log('国産車:', currentFilters.car_jp || '指定なし');
                    console.log('輸入車:', currentFilters.car_world || '指定なし');
                    console.log('現在のページ:', currentFilters.paged);
                    console.log('該当総数:', response.total + '件');
                    console.log('========================');
                }
                $('#stock-items').removeClass('loading');
            },
            error: function(xhr, status, error) {
                console.error('Ajax Error:', error);
                alert('エラーが発生しました。再度お試しください。');
                $('#stock-items').removeClass('loading');
            }
        });
    }

    // セレクトボックスの変更イベント
    $('#car_jp_filter, #car_world_filter').on('change', handleFilterChange);

    // ページネーションのクリックイベント（最終修正版）
    $(document).on('click', '.pagination a', function(e) {
        // フィルターが適用されている場合のみAjaxを使用
        if (hasActiveFilters()) {
            e.preventDefault();

            // data-page属性からページ番号を取得
            const pageNum = $(this).data('page');
            if (pageNum) {
                currentFilters.paged = parseInt(pageNum);
            } else {
                // fallback: URLからページ番号を抽出
                const href = $(this).attr('href');
                if (href && href.includes('/page/')) {
                    const match = href.match(/\/page\/(\d+)/);
                    currentFilters.paged = match ? parseInt(match[1]) : 1;
                } else {
                    currentFilters.paged = 1;
                }
            }

            filterStockCars();

            // スクロール調整
            const stockSection = document.querySelector('.stock');
            if (stockSection) {
                const headerElement = document.querySelector('header');
                const headerHeight = headerElement ? headerElement.offsetHeight : 0;
                const position = stockSection.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

                window.scrollTo({
                    top: position,
                    behavior: 'smooth'
                });
            }
        }
        // フィルターが適用されていない場合は通常のリンクとして動作
    });
});
/* ----- 在庫車フィルタリング（最終修正版）ここまで ----- */




// /* ----- 車両画像スライダー（グリッド版） ----- */
// document.addEventListener('DOMContentLoaded', function() {
//     // 車両画像スライダーが存在するかチェック
//     const mainSwiperElement = document.querySelector('.main-swiper');
//     const thumbsContainer = document.querySelector('.thumbs-swiper');

//     if (!mainSwiperElement || !thumbsContainer) {
//         // console.log('スライダー要素が見つかりません');
//         return; // 要素が存在しない場合は処理を終了
//     }

//     // Swiperライブラリが読み込まれているかチェック
//     if (typeof Swiper === 'undefined') {
//         console.warn('Swiperライブラリが読み込まれていません');
//         return;
//     }

//     // メインスライダーの初期化（loopをfalseに変更）
//     const mainSwiper = new Swiper('.main-swiper', {
//         spaceBetween: 10,
//         loop: false, // loopをfalseにして正確なインデックス管理
//         effect: 'fade',
//         fadeEffect: {
//             crossFade: true
//         },
//         // スライド変更時にサムネイルのアクティブ状態を更新
//         on: {
//             slideChange: function() {
//                 updateThumbnailActive(this.activeIndex);
//             }
//         }
//     });

//     // サムネイル取得
//     const thumbnails = document.querySelectorAll('.thumbs-swiper .swiper-slide');

//     // 関数で表示件数を決定
//     function getItemsPerPage() {
//       return window.innerWidth <= 767 ? 15 : 15; // スマホ9件、PC15件
//     }

//     let itemsPerPage = getItemsPerPage();
//     let currentPage = 0;
//     let totalPages = Math.ceil(thumbnails.length / itemsPerPage);

//     console.log(`サムネイル総数: ${thumbnails.length}, 総ページ数: ${totalPages}`);

//     // ウィンドウリサイズで再計算（既にあるなら統合）
//     window.addEventListener('resize', () => {
//       const newItemsPerPage = getItemsPerPage();

//       if (newItemsPerPage !== itemsPerPage) {
//         itemsPerPage = newItemsPerPage;
//         totalPages = Math.ceil(thumbnails.length / itemsPerPage);
//         currentPage = 0;

//         updateThumbnailDisplay();
//         updatePaginationInfo();
//       }
//     });


//     // ページネーション要素
//     const prevBtn = document.getElementById('thumb-prev');
//     const nextBtn = document.getElementById('thumb-next');
//     const currentPageSpan = document.getElementById('current-page');
//     const totalPagesSpan = document.getElementById('total-pages');

//     // 初期設定
//     updateThumbnailDisplay();
//     updatePaginationInfo();

//     // サムネイル表示更新
//     function updateThumbnailDisplay() {
//         thumbnails.forEach((thumb, index) => {
//             const pageIndex = Math.floor(index / itemsPerPage);
//             if (pageIndex === currentPage) {
//                 thumb.style.display = 'flex';
//             } else {
//                 thumb.style.display = 'none';
//             }
//         });
//     }

//     // サムネイルのアクティブ状態を更新
//     function updateThumbnailActive(activeIndex) {
//         thumbnails.forEach((thumb, index) => {
//             if (index === activeIndex) {
//                 thumb.classList.add('is-active');
//             } else {
//                 thumb.classList.remove('is-active');
//             }
//         });
//     }

//     // ページネーション情報更新
//     function updatePaginationInfo() {
//     if (currentPageSpan && totalPagesSpan) {
//       currentPageSpan.textContent = currentPage + 1;
//       totalPagesSpan.textContent = totalPages;
//     }

//     if (prevBtn) {
//       if (currentPage === 0) {
//         prevBtn.classList.add('is-hidden');
//       } else {
//         prevBtn.classList.remove('is-hidden');
//       }
//     }

//     if (nextBtn) {
//       if (currentPage >= totalPages - 1) {
//         nextBtn.classList.add('is-hidden');
//       } else {
//         nextBtn.classList.remove('is-hidden');
//       }
//     }

//     if (prevBtn) {
//       prevBtn.disabled = currentPage === 0;
//     }
//     if (nextBtn) {
//       nextBtn.disabled = currentPage >= totalPages - 1;
//     }

//     // ページが1つしかない場合はナビゲーション自体を非表示
//     const navigation = document.querySelector('.thumbnail-navigation');
//       if (navigation) {
//         if (totalPages <= 1) {
//           navigation.style.display = 'none';
//         } else {
//           navigation.style.display = 'flex';
//         }
//       }
//     }

//     // 前のページ
//     if (prevBtn) {
//         prevBtn.addEventListener('click', function() {
//             if (currentPage > 0) {
//                 currentPage--;
//                 updateThumbnailDisplay();
//                 updatePaginationInfo();
//             }
//         });
//     }

//     // 次のページ
//     if (nextBtn) {
//         nextBtn.addEventListener('click', function() {
//             if (currentPage < totalPages - 1) {
//                 currentPage++;
//                 updateThumbnailDisplay();
//                 updatePaginationInfo();
//             }
//         });
//     }

//     // サムネイルクリックでメイン画像変更（修正版）
//     thumbnails.forEach((thumb, index) => {
//         thumb.addEventListener('click', function(e) {
//             e.preventDefault(); // デフォルトの動作を防ぐ

//             // console.log(`サムネイル ${index} がクリックされました`);

//             // アクティブ状態を更新
//             updateThumbnailActive(index);

//             // メインスライダーを該当のスライドに移動
//             if (mainSwiper) {
//                 mainSwiper.slideTo(index, 300); // 300msのアニメーション付きで移動
//                 // console.log(`メインスライダーをスライド ${index} に移動`);
//             }

//             // クリックされたサムネイルが表示されているページに移動
//             const targetPage = Math.floor(index / itemsPerPage);
//             if (targetPage !== currentPage) {
//                 currentPage = targetPage;
//                 updateThumbnailDisplay();
//                 updatePaginationInfo();
//             }
//         });
//     });

//     // 最初のサムネイルをアクティブに
//     if (thumbnails.length > 0) {
//         updateThumbnailActive(0);
//     }

//     // ウィンドウリサイズ時の調整
//     window.addEventListener('resize', function() {
//         if (mainSwiper) {
//             mainSwiper.update();
//         }
//     });

//     // // デバッグ用：メインスライダーの情報を出力
//     // console.log('メインスライダー初期化完了');
//     // console.log('スライド数:', mainSwiper.slides.length);
// });
// /* ----- 車両画像スライダーここまで ----- */


/* ----- 車両画像スライダー(グリッド版) ----- */
document.addEventListener('DOMContentLoaded', function() {
  const mainSwiperElement = document.querySelector('.main-swiper');
  const thumbsContainer = document.querySelector('.thumbs-swiper');

  if (!mainSwiperElement || !thumbsContainer) {
    return;
  }

  if (typeof Swiper === 'undefined') {
    console.warn('Swiperライブラリが読み込まれていません');
    return;
  }

  // メインスライダーの初期化
  const mainSwiper = new Swiper('.main-swiper', {
    spaceBetween: 10,
    loop: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    on: {
      slideChange: function() {
        updateThumbnailActive(this.activeIndex);
      }
    }
  });

  const thumbnails = document.querySelectorAll('.thumbs-swiper .swiper-slide');

  // デバイス判定
  function isMobile() {
    return window.innerWidth <= 767;
  }

  // 表示件数を決定
  function getItemsPerPage() {
    return isMobile() ? 9 : 15;
  }

  let itemsPerPage = getItemsPerPage();
  let currentPage = 0;
  let totalPages = Math.ceil(thumbnails.length / itemsPerPage);

  const prevBtn = document.getElementById('thumb-prev');
  const nextBtn = document.getElementById('thumb-next');

  // 初期設定
  updateThumbnailDisplay();
  updatePaginationInfo();

  // サムネイル表示更新
  function updateThumbnailDisplay() {
    thumbnails.forEach((thumb, index) => {
      const pageIndex = Math.floor(index / itemsPerPage);
      if (pageIndex === currentPage) {
        thumb.style.display = 'flex';
      } else {
        thumb.style.display = 'none';
      }
    });
  }

  // サムネイルのアクティブ状態を更新
  function updateThumbnailActive(activeIndex) {
    thumbnails.forEach((thumb, index) => {
      if (index === activeIndex) {
        thumb.classList.add('is-active');
      } else {
        thumb.classList.remove('is-active');
      }
    });
  }

  // ページネーション情報更新
  function updatePaginationInfo() {
    const mobile = isMobile();

    // PCの場合は前へボタンを非表示
    if (prevBtn) {
      if (mobile) {
        // スマホ:通常の表示/非表示
        if (currentPage === 0) {
          prevBtn.classList.add('is-hidden');
        } else {
          prevBtn.classList.remove('is-hidden');
        }
        prevBtn.disabled = currentPage === 0;
      } else {
        // PC:常に非表示
        prevBtn.style.display = 'none';
      }
    }

    // 次へボタン
    if (nextBtn) {
      if (mobile) {
        // スマホ:最後のページで非表示
        if (currentPage >= totalPages - 1) {
          nextBtn.classList.add('is-hidden');
        } else {
          nextBtn.classList.remove('is-hidden');
        }
        nextBtn.disabled = currentPage >= totalPages - 1;
      } else {
        // PC:常に表示(ループするので)
        nextBtn.classList.remove('is-hidden');
        nextBtn.disabled = false;
        nextBtn.style.display = 'flex';
      }
    }

    // ページが1つしかない場合はナビゲーション自体を非表示
    const navigation = document.querySelector('.thumbnail-navigation');
    if (navigation) {
      if (totalPages <= 1) {
        navigation.style.display = 'none';
      } else {
        navigation.style.display = 'flex';
      }
    }
  }

  // 前のページ(スマホのみ)
  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      if (currentPage > 0) {
        currentPage--;
        updateThumbnailDisplay();
        updatePaginationInfo();
      }
    });
  }

  // 次のページ(PCではループ、スマホは通常)
  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      if (isMobile()) {
        // スマホ:通常のページング
        if (currentPage < totalPages - 1) {
          currentPage++;
          updateThumbnailDisplay();
          updatePaginationInfo();
        }
      } else {
        // PC:ループ処理
        if (currentPage < totalPages - 1) {
          currentPage++;
        } else {
          currentPage = 0; // 最後のページから最初に戻る
        }
        updateThumbnailDisplay();
        updatePaginationInfo();
      }
    });
  }

  // サムネイルクリックでメイン画像変更
  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      updateThumbnailActive(index);

      if (mainSwiper) {
        mainSwiper.slideTo(index, 300);
      }

      const targetPage = Math.floor(index / itemsPerPage);
      if (targetPage !== currentPage) {
        currentPage = targetPage;
        updateThumbnailDisplay();
        updatePaginationInfo();
      }
    });
  });

  // 最初のサムネイルをアクティブに
  if (thumbnails.length > 0) {
    updateThumbnailActive(0);
  }

  // ウィンドウリサイズ時の調整
  window.addEventListener('resize', function() {
    const newItemsPerPage = getItemsPerPage();
    if (newItemsPerPage !== itemsPerPage) {
      itemsPerPage = newItemsPerPage;
      totalPages = Math.ceil(thumbnails.length / itemsPerPage);
      currentPage = 0;
      updateThumbnailDisplay();
    }
    updatePaginationInfo(); // リサイズ時に必ずボタン表示を更新

    if (mainSwiper) {
      mainSwiper.update();
    }
  });
});
/* ----- 車両画像スライダーここまで ----- */



/* ----- galleryライトボックス ----- */
class LightboxGallery {
  constructor() {
    this.lightbox = document.getElementById('lightbox');
    this.lightboxImage = document.getElementById('lightbox-image');
    this.lightboxClose = document.getElementById('lightbox-close');

    this.galleryItems = document.querySelectorAll('[data-lightbox="gallery"]');

    // 必要な要素が揃っていない場合は何もせず終了
    if (!this.lightbox || !this.lightboxImage || !this.lightboxClose || this.galleryItems.length === 0) return;

    this.init();
  }

  init() {
    // 各画像にクリックイベントを追加
    this.galleryItems.forEach((item) => {
      item.addEventListener('click', () => {
        this.openLightbox(item);
      });
    });

    // 閉じるボタンのイベントリスナー
    this.lightboxClose.addEventListener('click', () => this.closeLightbox());

    // キーボードイベント（Escキーで閉じる）
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.lightbox.classList.contains('active')) {
        this.closeLightbox();
      }
    });

    // 背景クリックで閉じる
    this.lightbox.addEventListener('click', (e) => {
      if (e.target === this.lightbox) {
        this.closeLightbox();
      }
    });
  }

  openLightbox(item) {
    const src = item.dataset.src;
    const alt = item.dataset.alt;

    this.lightboxImage.src = src;
    this.lightboxImage.alt = alt;

    this.lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closeLightbox() {
    this.lightbox.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// ライトボックスを初期化
document.addEventListener('DOMContentLoaded', () => {
  new LightboxGallery();
});


/* ----- お客様の声スライダー ----- */
document.addEventListener('DOMContentLoaded', function() {
  const voiceSwiperElement = document.querySelector('.topVoice__items');

  if (!voiceSwiperElement) {
    return;
  }

  if (typeof Swiper === 'undefined') {
    console.warn('Swiperライブラリが読み込まれていません');
    return;
  }

  const voiceSwiper = new Swiper('.topVoice__items', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: true,
    speed: 600,
    centeredSlides: true, // スライドを中央配置
    freeMode: false,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    navigation: {
      prevEl: '.topVoice__btn.--prev',
      nextEl: '.topVoice__btn.--next',
    },

    // PC時の設定
    breakpoints: {
      768: {
        slidesPerView: 'auto', // 'auto'に変更
        spaceBetween: 64,
        centeredSlides: true,
      }
    }
  });
});
/* ----- お客様の声スライダーここまで ----- */
